import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { Link } from '@fiverr-private/typography';

interface ListLinkProps {
    children: React.ReactNode;
    collectionSlug: string;
    source?: string;
}

export const ListLink = ({ children, collectionSlug, source }: ListLinkProps) => {
    const {
        experience: { isBusiness },
    } = getContext();
    const query = source ? { source } : undefined;

    return isBusiness ? (
        <Link href={pathfinder('freelance_network_list_page', { slug: collectionSlug }, { query })}>{children}</Link>
    ) : null;
};
